import React from 'react'

//styles
import { loaderContainer, loader } from './styles'
import { vars } from '@/styles/v2/vars.css'

interface Props {
  size?: number
  background?: string
  color?: string
}

export const LoaderSpinner: React.FC<Props> = ({
  size = 20,
  background = vars.colors.green.secondary,
  color = vars.colors.pink.primary,
}) => {
  const spinnerStyle = {
    border: `${size * 0.2}px solid ${background}`,
    borderTop: `${size * 0.2}px solid ${color}`,
    width: size,
    height: size,
  }

  return (
    <div className={loaderContainer}>
      <div className={loader} style={spinnerStyle}></div>
    </div>
  )
}
